<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <label>状态</label>
          <el-select v-model="state" placeholder="Select" class="select-item">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <label>性别</label>
          <el-select v-model="sex" placeholder="Select" class="select-item">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="dialog-input-item">
          <label style="width: 8em">免费保障申请时间</label>
          <DatePickerRange title="" @date="getApplyTime($event)" @check="getApplyCheck($event)" :isChecked="isApplyChecked"/>
        </div>
        <div class="dialog-input-item">
          <DatePickerRange_1 title="邀请时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item">
          <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <el-checkbox v-model="limitState" style="margin-left: 8px"><span style="white-space: nowrap">有限制</span></el-checkbox>
        </div>
      </div>

      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <!--          <el-button type="success" @click="add">添加</el-button>-->
        </div>
        <div class="dialog-input-btn">
<!--          <ElButtons type="success" icon="Plus"  @click="checkDetail(-1)"> 添加 </ElButtons>-->
<!--          <el-button type="success" @click="add">添加</el-button>-->
        </div>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        @cell-click="toggleSelection"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="createTime" label="邀请时间"/>
      <el-table-column property="" label="被邀请人">
        <template #default="scope">
          <p>主人：{{scope.row.userName}}</p>
          <p>性别：{{scope.row.userSex == 1?'男':scope.row.userSex == 2?'女':''}}</p>
          <p>手机：{{scope.row.phone}}</p>
          <p>门店：{{scope.row.shopName}}</p>
          <p>主人ID：{{scope.row.uid}}</p>
        </template>
      </el-table-column>
      <el-table-column property="applyTime" label="免费保障申请时间"/>
      <el-table-column property="" label="邀请状态" >
        <template #default="scope">
          {{scope.row.state == 1?'成功':'未成功'}}
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import {getSecurityInvitePageList, } from '@/api/url';
import Dialog from '@/assets/js/dialog'
import DatePickerRange_1 from "@/components/DatePickerRange";
import DatePickerRange from "@/components/DatePickerRange";
import SearchComponents from "@/components/SearchComponents";
import UserInfo from "@/components/User/userInfo"
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, DatePickerRange_1, SearchComponents, UserInfo},
  data() {
    return {
      userAppletId: this.value.userAppletId,
      pageDataList: [],
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      sexArray: [
        {label: '不限', value: -1},
        {label: '未知', value: 0},
        {label: '男', value: 1},
        {label: '女', value: 2}
      ],
      sex: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '未成功', value: 0},
        {label: '成功', value: 1},
      ],
      state: -1,

      //消费时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //邀请时间
      applyStartTime: '',
      applyEndTime: '',
      isApplyChecked: true,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '主人ID', value : 3},
      ],
      searchType: 1,
      searchValue: '',

      shopIdArray: [],
      shopIdArr:[],
      shopId: 0,

      limitState: true,
    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getApplyTime(val) {
      this.applyStartTime = val[0];
      this.applyEndTime = val[1];
      // console.log(val)
    },
    getApplyCheck(val) {
      this.isApplyChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userAppletId'] = this.userAppletId;
      param['state'] = this.state;
      param['userSex'] = this.sex;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['applyStartTime'] = this.applyStartTime;
      param['applyEndTime'] = this.applyEndTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSecurityInvitePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },



  },
  mounted() {
    this.getPage();
  }
}
</script>

<style>

</style>
